import firebase from 'firebase'

const config = {
    apiKey: "AIzaSyBMyYBakqLdjWu7bERd5wiIpOLHv9710YY",
    authDomain: "stockmarket-4caf2.firebaseapp.com",
    databaseURL: "https://stockmarket-4caf2.firebaseio.com",
    projectId: "stockmarket-4caf2",
    storageBucket: "stockmarket-4caf2.appspot.com",
    messagingSenderId: "1063156308835",
    appId: "1:1063156308835:web:8d94467297a40e74cb1156",
    measurementId: "G-Z1FJNRVZXF"
}
firebase.initializeApp(config)

export default firebase
